'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Breadcrumb from 'Components/Front/Breadcrumb';
import Layout from 'Layouts/Front';
import NewCompanyForm from 'Components/Forms/Models/Company/NewCompanyForm';
import bemit from 'Functions/bemit';
import { URL } from 'Shared/Routes';
let app = typeof window !== 'undefined' ? window.app : undefined;
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Créer un compte entreprise',
  url: URL('CompanyCreateAccount')
}];
export default class CompanyCreateAccountPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
      meta_title: "Cr\xE9er un compte entreprise",
      meta_follow: false
    }), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['static-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, "Cr\xE9er un compte entreprise")))), /*#__PURE__*/React.createElement("div", {
      className: "front-internal-page"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), /*#__PURE__*/React.createElement(NewCompanyForm, null)));
    return output;
  }
}
